module.exports = __webpack_public_path__ + "img/45.9.TU.84dc44e9.png";